<template>
  <section>
    <!-- <header class="mui-bar mui-bar-nav">
      <a class="mui-action-back mui-icon mui-icon-left-nav mui-pull-left"></a>
      <h1 class="mui-title">已检一览</h1>
    </header> -->
    <div class="mui-content pd-8">
      <div class="title-name">
        <span class="">发货明细</span>
      </div>
      <!--基础信息-->
      <div class="sampling-first" style="border-bottom: 1px dashed #CCCCCC;font-size: 14px;margin-top: 15px;">
        <!--第一行-->
        <div class="sampling-first-title">
          <h4 style="position: relative;">基础信息
            <span style="position: absolute;right: 10px;font-size: 16px;"></span>
          </h4>
        </div>
        <!--第二行内容-->
        <div class="sampling-first-content">
          <div class="flex-container" style="padding-top: 0;padding-bottom: 0;">
              <div class="flex-content-container flex-4">
                <div class="flex-content-label" style="flex: none;min-width: 76px;">出库单号：</div>
                <div class="flex-content-span">{{shipmentno}}</div>
              </div>
              <div class="flex-content-container flex-3">
                 <div class="flex-content-label flex-strong" style="text-align: right;min-width: 100%;">{{zszt}}</div>
              </div>
          </div>
          <!--第2行-->
          <div class="flex-container"  style="padding-top: 0;padding-bottom: 0;">
            <div class="flex-content-container flex-1">
              <div class="flex-content-label" style="flex: none;min-width: 79px;">坯布品号：</div>
              <div class="flex-content-span">{{clothcode}}</div>
            </div>
          </div>
          <div class="flex-container"  style="padding-top: 0;padding-bottom: 0;">
            <div class="flex-content-container flex-1">
              <div class="flex-content-label" style="flex: none;min-width: 79px;">订单号：</div>
              <div class="flex-content-span">{{ddh}}</div>
            </div>
            <div class="flex-content-container flex-1">
              <div class="flex-content-label" style="flex: 3;text-align: right;">{{(ddqf!='2')?'抽检率：':''}}</div>
              <div class="flex-content-span">{{(ddqf!='2')?(randomcheckrate+'%'):''}}</div>
            </div>
          </div>
          <div class="flex-container"  style="padding-top: 0;padding-bottom: 0;">
              <div class="flex-content-container flex-1">
                 <div class="flex-content-label" style="min-width: 79px;">指示数量：</div>
                 <div class="flex-content-span flex-1">{{amount}}{{dw}}</div>
              </div>
            <div class="flex-content-container flex-1">
              <div class="flex-content-label" style="min-width: 30px;"></div>
              <div class="flex-content-span flex-1"></div>
            </div>
          </div>
          <div class="flex-container"  style="padding-top: 0;padding-bottom: 0;">
            <div class="flex-content-container flex-4">
              <div class="flex-content-label" style="min-width: 79px;">指示日期：</div>
              <div class="flex-content-span flex-1">{{schedate}}</div>
            </div>
            <div class="flex-content-container flex-3">
              <div class="flex-content-label" style="min-width: 30px;"></div>
              <div class="flex-content-span flex-1" style="position: relative;">
                <div class="" style="text-align: right;vertical-align: middle;position: absolute;right: 5px;top: -20px;" v-show="((statusflg=='1' || (statusflg=='2'&&(approveflg=='2'||zjapproveflg=='2'||zkapproveflg=='2'))||(statusflg=='3'&&approveflg=='2'))&&infoLst.length>0)&&(ddqf!='2')">
                  <button type="button" class="mui-btn mui-btn-primary btn-blue" style="width: 80px;" @tap="finish">指定完成</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="sampling-first" style="margin-top: 15px;border-bottom: 0px;">
        <!--第一行-->
        <div class="sampling-first-title">
          <h4 style="position: relative;text-align: left;">已指定明细（共计：{{infoLst.length}}卷 {{sjps_dis}}匹 {{hjsl}}{{dw}}）<!-- {{randomcheckflag=='0'?('抽检率（'+randomcheckrate+'%）抽检：'+jcjs+'卷'):''}} -->
            <span style="position: absolute;right: 10px;font-size: 30px;font-weight: bold;top:-5px;" @tap="scanQRCode" v-if="((statusflg=='1')||(approveflg=='2'||zjapproveflg=='2'||zkapproveflg=='2'))&&(ddqf!='2')"><img src="/static/images/richsacn.png"></span>
          </h4>
          <h4 style="position: relative;text-align: left;font-size:13px;" v-if="randomcheckflag=='0' && (ddqf!='2')">抽检合计：{{jcjs}}卷 已抽检率：{{sjcjl}}%
          </h4>
          <h4 style="position: relative;text-align: left;font-size:13px;" v-if="randomcheckflag=='0'">抽检率（卷）：{{sjcjl_j}}%（匹）：{{sjcjl_p}}%
          </h4>
        </div>
        <div class="sampling-first-content">
          <ul class="mui-table-view">
            <li class="mui-table-view-cell flex-content" style="display: block;margin-bottom: 10px;" v-for="(item,i) in infoLst">
              <div class="mui-slider-right mui-disabled" v-if="
(((statusflg=='1')||(((statusflg=='2')||(statusflg=='3'))&&(approveflg=='2'||zjapproveflg=='2'||zkapproveflg=='2')))||(item.cjgrade&&(item.cjgrade=='C')))&&(ddqf!='2')">
                <a class="mui-btn mui-btn-red" @tap="del(item.tsdrollno,$event)">删除</a>
              </div>
              <div class="mui-slider-handle">
                <div class="mui-table-cell">
                  <div class="flex-box" style="display: flex;flex-wrap:wrap;">
                    <div class="flex-container">
                      <div class="flex-content-container" style="display: flex;">
                        <div class="flex-content-span flex-1" style="width:21px;text-align:center;font-weight:bold;"><span>{{(i+1)}}</span></div>
                        <div class="flex-content-label" style="padding-right: 0px;min-width: 35px;">{{ddqf=='3'?'反番号':'外注卷号'}}：</div>
                        <div class="flex-content-span flex-1"><span style="white-space:nowrap;">{{item.wzrollno}}</span></div>
                      </div>
                    </div>
                    <div class="flex-container" style="margin-left: 5px;margin-right: 10px;">
                      <div class="flex-content-container flex-2" style="min-width:80px;display: flex;">
                        <div class="flex-content-label" style="min-width: 35px;padding-right: 0px;">数量：</div>
                        <div class="flex-content-span flex-1"><span>{{item.sl}}{{dw}}</span></div>
                      </div>
                    </div>
                    <div  class="flex-container" style="vertical-align: middle;display: table-cell;padding-top: 0px;">
                      <span class="flex-gray">{{item.grade=='B'?'悬念反':item.grade}}</span>
                      <span :class="[item.cjgrade=='B'?'flex-red':'flex-green']">{{item.cjgrade?(item.cjgrade=='B'?'悬念反':('抽（'+item.cjgrade+'）')):''}}</span>
                    </div>
                    <!--<div  class="flex-container" style="margin-left: 10px;">-->
                      <!--<span :class="[item.cjgrade=='B'?'flex-red':'flex-green']">{{item.cjgrade?(item.cjgrade=='B'?'悬念反':('抽（'+item.cjgrade+'）')):''}}抽（A）</span>-->
                    <!--</div>-->
                    <!--<div class="flex-container">-->
                      <!--<div class="flex-content-container flex-4">-->
                        <!--<span>TSD卷号:</span><span>{{item.tsdrollno}}</span>-->
                        <!--<div class="flex-content-span flex-7"></div>-->
                      <!--</div>-->
                      <!--<div class="flex-content-container flex-1"></div>-->
                    <!--</div>-->
                    <!--<div class="flex-container">-->
                      <!--<div class="flex-content-container flex-3">-->
                        <!--<span>数量:</span><span>{{item.sl}}{{dw}}</span><span style="margin-left: 10px;" class="flex-gray">{{item.grade=='B'?'悬念反':item.grade}}</span>-->
                      <!--</div>-->
                      <!--<div class="flex-content-container flex-1">-->
                        <!--<span :class="[item.cjgrade=='B'?'flex-red':'flex-green']">{{item.cjgrade?(item.cjgrade=='B'?'悬念反':('抽（'+item.cjgrade+'）')):''}}</span>-->
                      <!--</div>-->
                    <!--</div>-->
                  </div>
                </div>
              </div>
              <div class="t-right-new" v-if="(ddqf=='2' && item.scanflg == '1')"><p>扫</p></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "deliveryDetail",
  data() {
    return {
      shipmentno: "",
      ddh: "",
      wph: "",
      zszt: "",
      scxtwph: "",
      amount: "",
      dw: "",
      schedate: "",
      statusflg: "",
      approveflg: "",
      randomcheckflag: "",
      infoLst: [],
      hjsl: 0,
      xnfcount: 0,
      ddqf: "",
      randomcheckrate:0,
      jcjs:0,// 抽检卷数合计
      limitflag: "",
      limitup: "",
      limitdown: "",
      clothcode: "",
      sjcjl: 0,
      sjcjsl: 0,
      sjcjl_j: 0,
      sjcjl_p: 0,
      sjps_dis:0,
      delivery_min_flg: "",// 是否限制出库同轴最小卷 0:限制 1：不限制
      j_min_num: 0,// 同轴最小卷
      sale_nm: "",// 销售对象
      daylimitflg: "",// 在库周期限制
      daylimit: 0,// 限制在库天数
      zjapproveflg: "",// 同轴卷审核状态
      zkapproveflg: ""// 在库限制审核状态
    }
  },
  created() {
    this.nyy.wxInit();
  },
  activated() {
    var v = this;
    const para = getJsonPara(v.$route);
    if (para) {
      v.shipmentno = para.shipmentno;
      v.getDetail();
    }
  },
  methods: {
    del(tsdrollno,el) {
      var v = this;
      var li =$(el.target).parents('li');
      if(li.length<=0)return;
      li = li[0];
      mui.confirm('确定删除坯布卷号' + tsdrollno + '的记录 ?', '提示', ['否', '是'], function(e) {
        setTimeout(function() {
          mui.swipeoutClose(li);
        }, 0);
        
        if (e.index == 1) {
          v.nyy.doPost("/Delivery/del", {
              "ddh": v.ddh,
              "wph": v.wph,
              "shipmentno": v.shipmentno,
              "tsdrollno": tsdrollno
            },
            function(result) {
              if (result.status) {
                v.getDetail();
              } else {
                mui.toast(result.message);
              }
            }
          );
        }
      });
    },
    getDetail(callback) {
      var v = this;
      v.nyy.doPost("/Delivery/getDetail", {
          "shipmentno": v.shipmentno
        },
        function(result) {
          if (result.status) {
            var info = result.data.info;
            v.ddh = info.ddh;
            v.wph = info.wph;
            v.zszt = info.zszt;
            v.scxtwph = info.scxtwph;
            v.amount = info.amount;
            v.dw = info.dw;
            v.schedate = info.schedate;
            v.statusflg = info.statusflg;
            v.approveflg = info.approveflg;
            v.randomcheckflag = info.randomcheckflag;
            v.ddqf = info.ddqf;
            v.infoLst = info.list ? JSON.parse(info.list) : [];
            v.xnfcount = parseInt(info.xnfcount);
            v.limitflag = info.limitflag;
            v.limitup = info.limitup;
            v.limitdown = info.limitdown;
            v.clothcode = info.clothcode;
            if(info.randomcheckflag=="0"){
              v.randomcheckrate = info.randomcheckrate;
            }
            v.delivery_min_flg = info.delivery_min_flg;// 是否限制出库同轴最小卷 0:限制 1：不限制
            v.j_min_num = info.j_min_num;// 同轴最小卷
            v.sale_nm = info.sale_nm;// 销售对象
            v.daylimitflg = info.daylimitflg;// 在库周期限制
            v.daylimit = info.daylimit;// 限制在库天数
            v.zjapproveflg = info.zjapproveflg;// 同轴卷审核状态
            v.zkapproveflg = info.zkapproveflg;// 在库限制审核状态
            v.sumsl();
            if(callback)callback();
          }else{
            mui.toast(result.message);
          }
        }
      );
    },
    // 合计数量
    sumsl() {
      var v = this;
      var hjsl = 0;
      var jcjs = 0;
      // 实际抽检数量
      var sjcjsl = 0;
      // 实际匹数
      var sjps = 0;
      var cjps = 0;
      v.infoLst.forEach(function(element, index) {
        hjsl += parseFloat(element.sl);
        sjps += parseFloat(element.boltnum);
        if(element.cjgrade){
          jcjs++;
          sjcjsl += parseFloat(element.sl);
          cjps += parseFloat(element.boltnum);
        }
      });
      v.hjsl = hjsl.toFixed(1);
      v.jcjs = jcjs.toFixed(1);
      v.sjcjl = (parseFloat(v.hjsl)*100/parseFloat(v.amount)).toFixed(1);
      // 实际抽检数量
      v.sjcjsl = sjcjsl.toFixed(1);
      // 实际抽检数量/指定明细总数量
      v.sjcjl = (v.hjsl != 0) ? (parseFloat(v.sjcjsl)*100/parseFloat(v.hjsl)).toFixed(1) : 0;
      v.sjcjl_j = (v.infoLst.length != 0) ? (parseFloat(v.jcjs)*100/parseFloat(v.infoLst.length)).toFixed(1) : 0;
      v.sjcjl_p = (v.infoLst.length != 0) ?  (parseFloat(cjps)*100/parseFloat(sjps)).toFixed(1) : 0;
      v.sjps_dis = sjps.toFixed(1);
    },
    // 扫一扫
    scanQRCode() {
      var v = this;
      wx.scanQRCode({
        desc: 'scanQRCode desc',
        needResult: 1, // 默认为0，扫描结果由企业微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
          // 回调
          var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          if (!result > 1) {
            mui.toast('无效二维码')
          } else {
            // 扫TSD标签二维码，解析获取二维码的坯布信息，并保存到出库单下的明细中
            // TSD卷号截取，获取前8位 2020/06/28
            var rollstr = result.substr(0,8);
            v.addinfo(rollstr);
          }
        },
        error: function(res) {
          if (res.errMsg.indexOf('function_not_exist') > 0) {
            mui.toast('版本过低请升级')
          }
        }
      });
    },
    addinfo(tsdrollno) {
      var v = this;
      v.nyy.doPost("/Delivery/insertPicking", {
          "ddh": v.ddh,
          "wph": v.wph,
          "shipmentno": v.shipmentno,
          "randomcheckflag": v.randomcheckflag,
          "tsdrollno": tsdrollno,
          "clothcode": v.clothcode,
          "ddqf":v.ddqf
        },
        function(result) {
          if (result.status) {
            v.getDetail(function(){
              mui.confirm("是否继续指定明细?", '提示', ['否', '是'], function(e) {
                if (e.index == 1) {
                  // 继续该页面进行扫码
                  v.scanQRCode();
                }
              });
            });
          } else {
            mui.toast(result.message);
            mui.confirm(result.message + "<br/>是否重新扫码?", '提示', ['否', '是'], function(e) {
              if (e.index == 1) {
                // 继续该页面进行扫码
                v.scanQRCode();
              }
            });
          }
        }
      );
    },
    finish(){
      var v = this;
      // 判断当前明细有无C反，若存在，提示
      var cf = false;
      for(var i=0;i<v.infoLst.length;i++){
        if(v.infoLst[i].cjgrade && (v.infoLst[i].cjgrade=='C')){
          cf = true;
        }
      }
      if(cf){
        mui.toast("当前指定明细中存在已检C反，请删除");
        return;
      }
      // 允差范围判断 todo
      // 0：不限制 1：限制
      if(v.limitflag == "1"){
        // 上限
        var sx = (v.amount * (1 + v.limitup / 100)).toFixed(1);
        // 下限
        var xx = (v.amount * (1 - v.limitdown / 100)).toFixed(1);
        //alert(parseFloat(v.hjsl) +"<"+ parseFloat(xx) +":"+(parseFloat(v.hjsl) < parseFloat(xx))+"     "+parseFloat(v.hjsl) +">"+ parseFloat(sx)+":"+(parseFloat(v.hjsl) > parseFloat(sx)));
        if (parseFloat(v.hjsl) < parseFloat(xx) || parseFloat(v.hjsl) > parseFloat(sx)) {
            mui.alert("指定数量超出合理范围（" + xx + v.dw + "-" + sx + v.dw + "）","提示");
            return;
        } else {
            v.confirm_up();
        }
      }else{
        // 指示总数量amount和实际指定数量hjsl
        mui.confirm("本次要求发货数量:"+v.amount+",实际指定数量:"+v.hjsl, '提示', ['否', '是'], function(e) {
          if (e.index == 1) {
            v.confirm_up();
          }
        });
      }
    },
    confirm_up(){
      var  v = this;
      // 更新状态 2 
      var postMap = {
          shipmentno: v.shipmentno,
          statusflg: "2"
        };
      var sendmsg = false;
      // 订单状态是否抽检 0：抽检 1：不抽检
      if(v.randomcheckflag == "0"){

      }else{
        // 包含悬念反 发送通知，同时更新为状态：待审核
        if(v.xnfcount > 0){
          // 发送通知
          postMap = {
            shipmentno: v.shipmentno,
            statusflg: "2",
            approveflg: "0"
          }
          sendmsg = true;
        }else{
          // 不抽检
          postMap = {
            shipmentno: v.shipmentno,
            statusflg: "2",
            approveflg: "9"// 无需审核
          }
        }
      }
      // AB订单 校验
      if(v.ddqf == "3"){
        // 同轴最小卷校验 在库最大允许时间校验
        if(v.delivery_min_flg == "0" || v.daylimitflg == "0"){
          v.checkAB(function(check_info){
            var jminsendmsg = false;
            if(v.delivery_min_flg == "0"){
              if(check_info.jmin_flg){
                // 同轴卷审核状态 0:待审核 9:无需审核
                postMap.zjapproveflg = "0";
                jminsendmsg = true;
              }else{
                postMap.zjapproveflg = "9";
              }
            }
            var daylimitsendmsg = false;
            if(v.daylimitflg == "0"){
              if(check_info.day_flg){
                // 在库限制审核状态 0:待审核 9:无需审核
                postMap.zkapproveflg = "0";
                daylimitsendmsg = true;
              }else{
                postMap.zkapproveflg = "9";
              }
            }
            v.update(postMap, function(){
              if(jminsendmsg || daylimitsendmsg || sendmsg){
                if(jminsendmsg){
                  v.notifyMsg({
                    "content": "出库单" + v.shipmentno + "存在同轴卷数量不满足明细，等待审核",
                    "examine_type":"TZJ_MIN"
                  },function(){
                    //v.getDetail();
                  });
                }

                if(daylimitsendmsg){
                  v.notifyMsg({
                    "content": "出库单" + v.shipmentno + "存在在库时间超出范围明细，等待审核",
                    "examine_type":"ZK_LIMIT"
                  },function(){
                    //v.getDetail();
                  });
                }

                if(sendmsg){
                  v.notifyMsg({
                    "content": "出库单" + v.shipmentno + "存在悬念反明细，等待审核"
                  },function(){
                    //v.getDetail();
                  });
                }

                v.getDetail();
                
              }else{
                v.getDetail();
              }
            });
          });
          return;
        }
      }
      v.update(postMap, function(){
        if(sendmsg){
          v.notifyMsg({
            "content": "出库单" + v.shipmentno + "等待审核"
          },function(){
            v.getDetail();
          });
        }else{
          v.getDetail();
        }
      });
    },
    // 校验AB
    checkAB(callback){
      var v = this;
      var postMap = {
        shipmentno: v.shipmentno,
        delivery_min_flg: v.delivery_min_flg,
        j_min_num: v.j_min_num,
        daylimitflg: v.daylimitflg,
        daylimit: v.daylimit
      }
      v.nyy.doPost("/Delivery/checkAB", postMap,
        function(result) {
          if (result.status) {
            if(result.data.jmin_flg || result.data.day_flg){
              // 指示总数量amount和实际指定数量hjsl
              mui.confirm(" 指示明细中存在同轴卷数量不满足<br/>或在库时间超出范围,是否确认指定完成", '提示', ['否', '是'], function(e) {
                if (e.index == 1) {
                  if(callback) callback(result.data);
                }
              });
            }else{
              if(callback) callback(result.data);
            }
          } else {
            mui.toast(result.message);
          }
        }
      );
    },
    update(postMap, callback){
      var v = this;
      v.nyy.doPost("/Quality/update", postMap,
        function(result) {
          if (result.status) {
            if(callback) callback();
          } else {
            mui.toast(result.message);
          }
        }
      );
    },
    notifyMsg(postMap, callback){
      var v = this;
      v.nyy.doPost("/Notify/notifyMsg", postMap,
        function(result) {
          if (result.status) {
            if(callback) callback();
          } else {
            mui.toast(result.message);
          }
        }
      );
    }
  }
}
</script>
<style scoped>
@import "../../static/css/sampling.css";
@import "../../static/css/samplinghistory.css";
.t-right-new {
  position: absolute;
  width: 55px;
  height: 10px;
  background-color: red;
  color: white;
  text-align: center;
  transform: rotate(-40deg);
  top: 1px;
  left: -20px;
}
.t-right-new p {
font-size: 10px;
line-height: 12px;
margin: 0;
color:#fff;
}

</style>



// WEBPACK FOOTER //
// src/components/deliveryDetail.vue